import { useState } from 'react';
import Modal from '../../components/modals/Modal';
import { Text } from '../../components/typography';
import styles from './RiskRegistryImportModal.module.scss';
import { MAX_FILE_UPLOAD_SIZE } from '../../constants/misc';
import { downloadFile } from '../../utilities/inspection';
import TextWithIcon from '../../components/typography/TextWithIcon';
import { loader } from 'graphql.macro';
import { useMutation } from '@apollo/client';
import ExcelImport from '../../components/excel/ExcelImport';
import { convertRegistryImport } from '../../utilities/risk_registry';

const addRiskRegistryMutation = loader('./RiskRegistryList.add.graphql');

const riskImport =
  'https://devassets.opasmobile.com/assets/2/8b1f3560-a157-4686-bb18-86a1c64211fa.xlsx';

export default function RiskRegistryImportModal({ show, setShow }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addRiskRegistry] = useMutation(addRiskRegistryMutation);
  const [data, setData] = useState(null);

  async function uploadRiskRegistryFile(file) {
    addRiskRegistry({ variables: data });
  }

  const onHide = () => {
    setFile(null);
    setLoading(false);
    setShow(false);
  };

  const handleImport = async () => {
    if (!file.fileToUpload) return;
    setLoading(true);
    try {
      await uploadRiskRegistryFile(file);
      setTimeout(() => onHide(), 1000);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setFile(null);
    }
  };

  return (
    <Modal
      title={'Import Risk Registry'}
      open={show}
      submitDisabled={!file || loading || file.size > MAX_FILE_UPLOAD_SIZE}
      onClose={onHide}
      onSubmit={handleImport}
      submitText={loading ? 'Importing…' : 'Import'}
    >
      <div className={styles.container}>
        <TextWithIcon weight="semiBold" textAlign="center">
          This import requires a specific data structure and only accepts Excel
          or CSV file types.
        </TextWithIcon>
        <Text textAlign="center">
          Download excel template{' '}
          <span
            className={styles.link}
            target="blank"
            download
            onClick={() =>
              downloadFile(riskImport, 'OPAS_Risk_Registry_Import')
            }
          >
            here
          </span>
        </Text>
        <br />
        <ExcelImport
          setFile={setFile}
          file={file}
          onLoading={() => setLoading(true)}
          onSubmit={({ row }) => {
            const formatted = convertRegistryImport(row);
            setData(formatted);
          }}
        />
      </div>
    </Modal>
  );
}
